// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-product__label{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:18px;padding:0 4px;line-height:18px;display:inline-block;flex-shrink:0;position:relative;font-size:12px;cursor:default;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.plv-iar-product__label__content{display:inline-block;transform:translate3d(0, 0, 0) scale(0.83)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
